var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_2179",
  "data-name": "Group 2179",
  transform: "translate(-628 252)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_295",
  "data-name": "Rectangle 295",
  width: 24,
  height: 24,
  rx: 12,
  transform: "translate(628 -252)",
  fill: "#c7c7c7"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2163",
  "data-name": "Group 2163",
  transform: "translate(1 -1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "flash",
  d: "M125.707,5.687H121.02L125.365,0h-5.474l-5.132,8.531h3.551l-2.655,7.35Z",
  transform: "translate(518.534 -247.001)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "flash-2",
  "data-name": "flash",
  d: "M121.759,4.483h-3L121.54,0h-3.5l-3.281,6.724h2.581L114.759,13Z",
  transform: "translate(520.241 -245.508)",
  fill: "#c7c7c7"
})))));
export default __webpack_public_path__ + "static/media/express-inactive.c1e8ad53.svg";
export { SvgComponent as ReactComponent };